export const paymentMethodTypes = {
  SEPA: 'sepa_debit',
  SEPA_LEGACY: 'sepa', // if stripe sources api has been used
  CARD: 'card',
};
